import Icon from '../components/Icon.vue'

Icon.register({
  'hat-wizard': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H496C504.8 512 512 504.8 512 496V464C512 455.2 504.8 448 496 448zM192 384L128 352 192 320 224 256 256 320 320 352 256 384 240 416H448L361.6 214.4A64-64 0 0 0 359.7 168.9L416 0 228.4 107.2A128-128 0 0 1 175 166.3L64 416H208L192 384zM256 160L272 128 288 160 320 176 288 192 272 224 256 192 224 176 256 160z'
      }
    ]
  }
})
